import React, { Component } from 'react';
import './Footer.css';

import iconFacebook from '../assets/imgs/b-social-fb.png';
import iconInstagram from '../assets/imgs/b-social-instagram.png';
import iconTwitter from '../assets/imgs/b-social-twitter.png';
import iconYelp from '../assets/imgs/b-social-yelp.png';

class Footer extends Component {
  render() {
    return (
      <div className="Footer-container">
        <div className="Footer-social-icons">
          <div className="Footer-social-icon">
            <a
              href="https://www.facebook.com/Thebunkerexperience/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img src={iconFacebook} alt="" />
            </a>
          </div>
          <div className="Footer-social-icon">
            <a
              href="https://www.instagram.com/thebunkerexperience/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img src={iconInstagram} alt="" />
            </a>
          </div>
          <div className="Footer-social-icon">
            <a href="https://twitter.com/BunkerEx" target="_blank" rel="noopener noreferrer">
              <img src={iconTwitter} alt="" />
            </a>
          </div>
          <div className="Footer-social-icon">
            <a
              href="http://www.yelp.com/biz/the-bunker-experience-pasadena"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img src={iconYelp} alt="" />
            </a>
          </div>
        </div>
        <div className="Pricing-text">
        <center>
        <br></br>
        <b>CONTACT US</b><br></br>
        <a href="mailto:thebunkerexperience@gmail.com" target="_blank" rel="noopener noreferrer">thebunkerexperience@gmail.com</a><br></br>
        20 N. Raymond Ave., Pasadena, CA 91103<br></br>
        Phone: 626-487-9777<br></br>
        </center>
        </div>
      </div>
    );
  }
}

export default Footer;
